module.exports = __webpack_public_path__ + "static/media/chatbubbles.51209c30.svg";